import React from "react";
import baseUrl from "../../../Http/backend-base-url";
import { Download } from "react-iconly";
import { useTranslation } from "react-i18next";

function DocumentFile({ document }) {
  const { t } = useTranslation();
  const get_url_extension = (url) => {
    return url.split(/[#?]/)[0].split(".").pop().trim();
  };

  return (
    <div className="modal-dialog modal-dialog-centered modal-xl">
      <div className="modal-content">
        <div className="modal-header py-3">
          <h5 className="modal-title text-titre" id="addCommentModal">
            Document
          </h5>
          <button
            type="button"
            className="close btn-close-modal-comment"
            data-dismiss="modal"
            aria-label="Close"
            //   onClick={() => handleReset()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div>
          <div className="modal-body">
            <div className="bloc-entete-document py-4">
              <div>
                {/* <NavLink to="/app/documents" className="no-link">
                  <CaretLeft set="bold" primaryColor="#000" />
                </NavLink> */}
              </div>
              <div>
                <a
                  className="btn btn-download-document"
                  // onClick={() =>
                  //   download(baseUrl + document?.fichier, document?.title)
                  // }
                  href={baseUrl + document?.fichier}
                  download
                  target="_blank"
                >
                  <Download set="bold" primaryColor="#003DA5" />
                  <span className="pl-2">{t("download")}</span>
                </a>
              </div>
            </div>
            <div className="pb-5 pt-3 text-center " style={{ height: "800px" }}>
              {get_url_extension(document?.fichier) === "pdf" ? (
                <iframe
                  src={baseUrl + document?.fichier}
                  frameborder="0"
                  width={`100%`}
                  height={`100%`}
                ></iframe>
              ) : (
                <iframe
                  src={
                    "https://view.officeapps.live.com/op/embed.aspx?src=" +
                    baseUrl +
                    document?.fichier
                  }
                  frameborder="0"
                  width={`100%`}
                  height={`100%`}
                ></iframe>
              )}{" "}
              {/* <object data={baseUrl + document?.fichier} /> */}
            </div>
            {/* <div className="pb-5 mb-5">
                <p className="text-paragraph" style={{ color: "#000000" }}>
                  {document?.description}
                  
                </p>
              </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DocumentFile;
